import { render } from "./ConsentVersionPage.vue?vue&type=template&id=c4cbc03e&ts=true"
import script from "./ConsentVersionPage.vue?vue&type=script&lang=ts"
export * from "./ConsentVersionPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Dashboard/Consent/ConsentVersionPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c4cbc03e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c4cbc03e', __exports__)) {
    api.reload('c4cbc03e', __exports__)
  }
  
  module.hot.accept("./ConsentVersionPage.vue?vue&type=template&id=c4cbc03e&ts=true", () => {
    api.rerender('c4cbc03e', render)
  })

}


export default __exports__